import React, { useState, useContext, useEffect } from "react";
import ConfigContext from "../context/ConfigContext";
import GC from "@grapecity/spread-sheets";
import { SpreadSheets } from "@grapecity/spread-sheets-react";
import reportLoader from "../content/images/search_loading.gif";
import ExcelRequestContract from "../contracts/ExcelRequestContract";
import { fetchReport, setBlobFromData, configureSheet, spreadActiveSheetChanged } from "../Utils/ReportUtils";
import "./spreadTheme.css";

// Import ExcelIO module
import * as ExcelIO from "@grapecity/spread-excelio";

// axios.get("api/Settings/GetJsSpreadLicense").then((result) => {
const spreadJsLicense = "devqaprod,348928238523931#B0LevJHbBdEVPJmbnJVdClkcFZ6UwkHS654Yr36Zw8Gai5UQr5mZplmQ5dFahFFcYdldChkS8sSSaxUZ8lGZudDZrd6aTREUnl6QRRTY74UZQJzRWlnblJ7KPplMQtmShNUMFBjU6NGRLFlRBNUWQx4LnFkR93yMKpWckRUMBZTczdVRvoWbw24Qrd7Yt3EaJZFZpxkbqpGT8IDWBlTYhlmavk5ZmtUMPtyNjhGRRRTTM5UUJdWZNdmRGNVUEd6byJGdvZ7RLV5cnlDRWtyU92mUU9mWxgGZYNHNsFzVzg7MRNmNqtES5U5KKNmdvgmTV9GdhRGV7RTZERneSJmbEdTVXB5LGV7SRJ6UoJUNIlURxd7aycjR8MFbQ3SVvVzdwonVBdHVsRnRyI7akZmI0IyUiwiI4QEN7MkR7UjI0ICSiwCNygTM9kTOyYTM0IicfJye#4Xfd5nIFVUSWJiOiMkIsICNx8idgAyUKBCZhVmcwNlI0IiTis7W0ICZyBlIsISOyMzM7ADIyAjMxEjMwIjI0ICdyNkIsISbvNmLsFWaj9WYulmZhJHdzV6auYXZkNHduVWblRXY4NnbvlGdhNnblBXbvNGLt36YuwWYpNmbh9WamFmc4NXZr9SYxNHduVWblRXY4NnbvlGdhNnblBXbvNGLt36YuwWYpNmbh9WamFmc4NXZr9yc49WZtVGdhR7cu3Wa4F6cuVGct36YiojIz5GRiwiIzdmbpRGbvhEIhJHdzV6SiojIh94QiwiIxMTOzITN8MjM8ITO8QzMiojIklkIs4XXbpjInxmZiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34zZoFFSq3ENpVjcygGVaVDUTlDdCZ7d0dnaHpkRxt6dvE7R5wmURJJRvV";
GC.Spread.Sheets.LicenseKey = spreadJsLicense;
ExcelIO.LicenseKey = spreadJsLicense;
// });

export const ReportFullView = ({ spread, setSpread, payPeriod, clientNumber }) => {
	const configData = useContext(ConfigContext);
	const hostStyle = { height: "100%", width: "100%" };
	const [exportBlob, setExportBlob] = useState(null);
	const [reportLoading, setReportLoading] = useState(true);
	const [hasError, setHasError] = useState(false);
	const [noData, setNoData] = useState(false);

	useEffect(() => {
		generateReport();
		document.body.style.overflowY = "hidden";
	}, [spread]);

	const generateReport = () => {
		if (clientNumber != null && payPeriod != null && spread) {
			const excelRequest = new ExcelRequestContract(clientNumber.toString(), payPeriod.payCycle, null, payPeriod.isPending);
			fetchReport(excelRequest, configData.REACT_APP_EXCEL_URL).then((result) => {
				if (result.status === 204) {
					setNoData(true);
					setReportLoading(false);
				} else {
					const blob = setBlobFromData(result.data);
					const excelIO = new ExcelIO.IO();
					excelIO.open(blob, (json) => {
						spread.fromJSON(json);
						const activeSheet = spread.getActiveSheet();
						configureSheet(activeSheet, spread);
						setExportBlob(blob);
						setReportLoading(false);
					}, (e) => {
						console.log("SpreadSheet error: ", e);
						setReportLoading(false);
						setHasError(true);
					});
				}
			}).catch(e => {
				console.log("Fetch report error: ", e.message);
				setReportLoading(false);
				setHasError(true);
			});
		}
	};

	return (
		<div>
			<div style={{ textAlign: "center" }}>
				{reportLoading && <img src={reportLoader} alt="Loading " />}
				{hasError && <div>Error loading Compensation Report</div>}
				{noData && <div>No data is available for the selected period</div>}
			</div>
			<div style={(reportLoading || hasError || noData) ? { visibility: "hidden" } : { padding: "0px" }}>
				<SpreadSheets workbookInitialized={setSpread} activeSheetChanged={spreadActiveSheetChanged} hostStyle={hostStyle}
					hostClass="col-md-12 col-lg-12 vh-100">
				</SpreadSheets>
			</div>
		</div>
	);
};